import { getCurrentInstance } from 'vue';
import type { Plugin } from 'vue';
import { Vue3 } from './env';

export const fetchPlugin: Plugin = function (_Vue) {
  _Vue.mixin({
    async serverPrefetch() {
      if (Vue3) {
        const instance = getCurrentInstance();
        if (!instance)
        { return; }
        const options = instance.type;
        if (!options || !('fetch' in options))
        { return; }
        if (typeof options.fetch === 'function') {
          await options.fetch.call(instance.proxy);
        }
      } else {
        const fetch = this.$options.fetch;
        if (fetch && typeof fetch === 'function') {
          await fetch.call(this);
        }
      }
    },

    async created() {
      if (typeof window !== 'undefined') {
        if (Vue3) {
          const instance = getCurrentInstance();
          if (!instance)
          { return; }
          const options = instance.type;
          if (!options || !('fetch' in options))
          { return; }
          if (typeof options.fetch === 'function') {
            await options.fetch.call(instance.proxy);
          }
        } else {
          const fetch = this.$options.fetch;
          if (fetch && typeof fetch === 'function') {
            await fetch.call(this);
          }
        }
      }
    },
  });
};
